import { StatusChipVariant } from '@occc/ui-design-system';
import { SteeringWalletBasis, SteeringWalletStatus, Unit_Of_Measure } from '@occc/graphql';

export const titleByBasis: Record<SteeringWalletBasis, string> = {
  [SteeringWalletBasis.Daily]: 'daily',
  [SteeringWalletBasis.Weekly]: 'weekly',
  [SteeringWalletBasis.Monthly]: 'monthly',
};

export const titleByUnitOfMeasure: Record<Unit_Of_Measure, string> = {
  [Unit_Of_Measure.Amount]: 'Money Amount',
  [Unit_Of_Measure.Unit]: 'Selling Unit',
  [Unit_Of_Measure.Gallon]: 'Gallons',
};

export const titleByStatus: Record<SteeringWalletStatus, string> = {
  [SteeringWalletStatus.Active]: 'Active',
  [SteeringWalletStatus.Archived]: 'Archived',
  [SteeringWalletStatus.Draft]: 'Draft',
};

export const chipVariantByStatus: Record<SteeringWalletStatus, StatusChipVariant> = {
  [SteeringWalletStatus.Active]: 'success',
  [SteeringWalletStatus.Archived]: 'error',
  [SteeringWalletStatus.Draft]: 'default',
};

export const WALLETS_STATUS_ALL = 'ALL';

export const STATUS_PARAM = 'status';

export const statusFilterOptions = [
  { label: 'All', value: WALLETS_STATUS_ALL },
  { label: 'Active', value: SteeringWalletStatus.Active },
  { label: 'Draft', value: SteeringWalletStatus.Draft },
  { label: 'Archived', value: SteeringWalletStatus.Archived },
];
